import { BufferStorage } from "model";

class StorageManager {
  private COOKIE_STORED_DAYS = 30;
  private storageKey = "DSLOG";
  private targetStorage:
    | BufferStorage.COOKIE_STORAGE
    | BufferStorage.LOCAL_STORAGE
    | null;
  private recordsLimit: number;
  private useBuffer: boolean;

  constructor({
    recordsLimit,
    useBuffer
  }: {
    recordsLimit: number;
    useBuffer: boolean;
  }) {
    if (!useBuffer) {
      this.targetStorage = null;
      this.recordsLimit = 0;
      this.useBuffer = false;
    }

    if (this.isLocalStorageAvailable()) {
      this.targetStorage = BufferStorage.LOCAL_STORAGE;
    } else if (this.isCookieStorageAvailable()) {
      this.targetStorage = BufferStorage.COOKIE_STORAGE;
    } else {
      this.targetStorage = null;
    }

    this.recordsLimit = recordsLimit;
    this.useBuffer = useBuffer && !!this.targetStorage;
  }

  private isLocalStorageAvailable() {
    try {
      window.localStorage.setItem("__test__", "__test__");
      window.localStorage.getItem("__test__");
      window.localStorage.removeItem("__test__");
      return true;
    } catch (e) {
      return false;
    }
  }

  private isCookieStorageAvailable() {
    try {
      if (navigator.cookieEnabled) return true;
      document.cookie = "cookietest=1";
      const ret = document.cookie.indexOf("cookietest=") != -1;
      document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
      return ret;
    } catch (e) {
      return false;
    }
  }

  private getCookie(cname: any) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  private setItem(item: any) {
    if (this.targetStorage === BufferStorage.LOCAL_STORAGE) {
      return window.localStorage.setItem(this.storageKey, JSON.stringify(item));
    }

    if (this.targetStorage === BufferStorage.COOKIE_STORAGE) {
      const currentDate = new Date();
      const expireDate = new Date(
        currentDate.setTime(
          currentDate.getTime() + this.COOKIE_STORED_DAYS * 24 * 60 * 60 * 1000
        )
      );
      return (document.cookie = `${this.storageKey}=${JSON.stringify(
        item
      )}; expires=${expireDate.toUTCString};`);
    }

    return JSON.stringify([item]);
  }

  get getLogs() {
    let storedLogs;

    if (this.targetStorage === BufferStorage.LOCAL_STORAGE) {
      storedLogs = window.localStorage.getItem(this.storageKey);
    }

    if (this.targetStorage === BufferStorage.COOKIE_STORAGE) {
      storedLogs = this.getCookie(this.storageKey);
    }

    if (!storedLogs) return [];

    return JSON.parse(storedLogs);
  }

  push(data: any, callback?: any) {
    const { useBuffer, recordsLimit } = this;

    const updatedLogs = this.getLogs;
    // updatedLogs.push(data);
    const newLog = [...updatedLogs, ...data];
    this.setItem(newLog);

    if (!useBuffer || recordsLimit <= updatedLogs.length) callback(newLog);
  }

  clear() {
    if (!this.targetStorage) return;

    this.setItem([]);
  }
}

export default StorageManager;
